/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Eyebrow_StagesInputs */

const en_directory_ai_tools_eyebrow_stages = /** @type {(inputs: Directory_Ai_Tools_Eyebrow_StagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stages`)
};

const zh_directory_ai_tools_eyebrow_stages = /** @type {(inputs: Directory_Ai_Tools_Eyebrow_StagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`舞台`)
};

/**
* | output |
* | --- |
* | "Stages" |
*
* @param {Directory_Ai_Tools_Eyebrow_StagesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_eyebrow_stages = /** @type {((inputs?: Directory_Ai_Tools_Eyebrow_StagesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Eyebrow_StagesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_eyebrow_stages(inputs)
	return zh_directory_ai_tools_eyebrow_stages(inputs)
});
export { directory_ai_tools_eyebrow_stages as "directory.ai_tools.eyebrow.stages" }